var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audit-logs-details-dialog-layout',{attrs:{"close-handler":_vm.dispatchCloseEvent}},[_c('pre',{staticClass:"audit-logs-details-dialog__json",domProps:{"textContent":_vm._s(_vm.formattedItem)}})])}
var staticRenderFns = []

export { render, staticRenderFns }